import React from 'react'
import { addCustomEvent } from '../firebase'

class AddTile extends React.Component {

  constructor() {
    super()
    this.state = {
      person: "",
      name: "",
      start: "0800",
      end: "0800",
      day: "Monday",
      errorText: ""
    }
  }

  componentDidMount() {
    this.setState({ person: this.props.users[0].name })
  }

  onNameChange = (event) => {
    this.setState({ name: event.target.value })
  }

  onPersonChange = (event) => {
    this.setState({ person: event.target.value })
  }

  onStartChange = (event) => {
    this.setState({ start: event.target.value }, () => console.log(this.state))
  }

  onEndChange = (event) => {
    this.setState({ end: event.target.value }, () => console.log(this.state))
  }

  onDayChange = (event) => {
    this.setState({ day: event.target.value })
  }

  addTile = () => {
    if (parseInt(this.state.start) < parseInt(this.state.end)) {
      // valid 
      let tileDetails = {
        day: this.state.day,
        start: this.state.start,
        end: this.state.end,
        name: this.state.name
      }
      addCustomEvent(this.props.room, this.state.person, tileDetails)

    } else {
      this.setState({ errorText: "Start time cannot be later than end time" })
    }
  }


  render() {
    return (
      <div className="AddTile mx-auto text-center p-4">
        <select className="custom-select p-2" value={this.state.person} onChange={this.onPersonChange}>
          {this.props.users.map((users, key) => {
            return <option key={key} value={users.name}>{users.name}</option>
          })}
        </select>

        <div className="input-group p-2">
          <input type="text" className="form-control" placeholder="Event name" value={this.state.name} onChange={this.onNameChange} />
        </div>

        <div className="row p-2">
          <div className="col-2">Day:</div>
          <div className="col-4">
            <select className="custom-select" value={this.state.day} onChange={this.onDayChange} >
              <option value="Monday">Monday</option>
              <option value="Tuesday">Tuesday</option>
              <option value="Wednesday">Wednesday</option>
              <option value="Thursday">Thursday</option>
              <option value="Friday">Friday</option>
            </select>
          </div>

        </div>

        <div className="row p-2 mb-3">
          <div className="col-2">Start time:</div>
          <div className="col-4">
            <select className="custom-select" value={this.state.start} onChange={this.onStartChange}>
              <option value="0800">0800</option>
              <option value="0900">0900</option>
              <option value="1000">1000</option>
              <option value="1100">1100</option>
              <option value="1200">1200</option>
              <option value="1300">1300</option>
              <option value="1400">1400</option>
              <option value="1500">1500</option>
              <option value="1600">1600</option>
              <option value="1700">1700</option>
              <option value="1800">1800</option>
              <option value="1900">1900</option>
              <option value="2000">2000</option>
              <option value="2100">2100</option>
              <option value="2200">2200</option>
            </select>
          </div>
          <div className="col-2">End time:</div>
          <div className="col-4">
            <select className="custom-select" value={this.state.end} onChange={this.onEndChange}>
              <option value="0800">0800</option>
              <option value="0900">0900</option>
              <option value="1000">1000</option>
              <option value="1100">1100</option>
              <option value="1200">1200</option>
              <option value="1300">1300</option>
              <option value="1400">1400</option>
              <option value="1500">1500</option>
              <option value="1600">1600</option>
              <option value="1700">1700</option>
              <option value="1800">1800</option>
              <option value="1900">1900</option>
              <option value="2000">2000</option>
              <option value="2100">2100</option>
              <option value="2200">2200</option>
            </select>
          </div>

        </div>

        <div className="small text-danger mb-3">{this.state.errorText}</div>

        <button className="btn btn-success" style={{ borderRadius: 50 }} onClick={this.addTile}>Add</button>
      </div>
    )
  }
}

export default AddTile